"use strict";

import { createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import grey from '@material-ui/core/colors/grey';
var defTheme = createMuiTheme();
export var lightTheme = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    primary: blue,
    customColors: {
      drawer: {
        header: {
          bg: defTheme.palette.common.white,
          color: defTheme.typography.caption.color,
          titleHover: blue[500]
        },
        listItem: {
          color: defTheme.typography.subtitle2.color,
          subItems: {
            color: defTheme.typography.caption.color,
            active: {
              color: blue[500]
            }
          }
        },
        version: defTheme.typography.caption.color
      }
    }
  }
});
var blueThemePalette = {
  primary: {
    light: '#73bdef',
    main: '#3c8dbc',
    dark: '#367FAC',
    contrastText: '#fff'
  },
  darBackGround: '#222d32'
};
export var blueTheme = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    primary: blueThemePalette.primary,
    customColors: {
      drawer: {
        header: {
          bg: blueThemePalette.primary.dark,
          color: defTheme.palette.common.white,
          titleHover: defTheme.palette.common.white
        },
        listItem: {
          color: defTheme.palette.common.white,
          subItems: {
            color: grey[300],
            active: {
              color: defTheme.palette.common.white
            }
          }
        },
        version: grey[300]
      }
    }
  },
  overrides: {
    // Name of the component ⚛️ / style shee
    MuiDrawer: {
      // Name of the rule
      paper: {
        // Some css
        background: blueThemePalette.darBackGround
      },
      paperAnchorDockedLeft: {
        borderRight: 'none'
      },
      paperAnchorDockedRight: {
        borderLeft: 'none'
      }
    }
  }
});